module.exports = __webpack_public_path__ + "static/media/arrowhovercal.94d6e1d7.webp";